import React from 'react';
import { useSelector } from 'react-redux';
import { BeFi20Card } from './components/BeFi20Card/BeFi20Card';
import { PLDCard } from './components/PLDCard/PLDCard';
import { externalHostSelector as selectExternalHostSelector } from '../../../../ConsumerArea/ConsumerAreaSelector';
import { useIsPdf } from '../../../hooks/useIsPdf';
import { PulseCheckCard } from './components/PulseCheckCard/PulseCheckCard';
import { Wrapper } from './HighlightGoals.styles';

export const HighlightGoals = () => {
  const externalHost = useSelector(selectExternalHostSelector);
  const isPdf = useIsPdf();

  if (isPdf || externalHost) {
    return null;
  }

  return (
    <Wrapper>
      <BeFi20Card />
      <PLDCard />
      <PulseCheckCard />
    </Wrapper>
  );
};
